"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookLoginButton = void 0;
var FacebookLoginButton_1 = require("./FacebookLoginButton");
Object.defineProperty(exports, "FacebookLoginButton", { enumerable: true, get: function () { return FacebookLoginButton_1.FacebookLoginButton; } });
